const argsHc = (contrato, relacion, valor, userLogin, descripcion, detalle, movimiento, fechaHoraHoy) => {
  // let fechaHoy = new Date()
  // let horaHoy = fechaHoy.getHours()+":"+fechaHoy.getMinutes()+":"+fechaHoy.getSeconds();
  // fechaHoy = (fechaHoy.getFullYear()) + '-' + ((fechaHoy.getMonth()+1)<10?'0'+(fechaHoy.getMonth()+1):(fechaHoy.getMonth()+1)) + '-' + (fechaHoy.getUTCDate()<10?'0'+fechaHoy.getUTCDate():fechaHoy.getUTCDate())
  let fechaHoy = fechaHoraHoy.substr(0, 10)
  let horaHoy = fechaHoraHoy.substr(11, 8)

  let creaColecc = []
  let argsAdd = {
    "fechaHistCliente": fechaHoy + ' ' + horaHoy,
    "contrato": contrato,
    "movimiento": movimiento,
    "descripcion": descripcion,
    "detalle": detalle,
    "relacion": relacion,
    "valor": valor,
    "usuarioCreate": userLogin,
  }
  creaColecc.push(argsAdd)

  let colecc = {creaColecc}

  return colecc
}

export default argsHc
